import { Box, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ResponsiveContainer, ComposedChart, LineChart, Bar, Line, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, BarChart } from 'recharts';
import ResponsiveLegend from "utils/ResponsiveLegendChart";
import { formateMonthName } from "utils/formats";

export default function DespesaPessoalChart({ despesaPessoalData }) {

    const [chartAndTableData, setChartAndTableData] = React.useState([]);
    const { getLegendPosition, windowWidth } = ResponsiveLegend();

    useEffect(() => {
        if (despesaPessoalData && despesaPessoalData.length > 0) {
            let mappedData = despesaPessoalData.map((data) => ({
                name: formateMonthName(data.mesAno),
                gerentePdv: data.gerentePdv,
                vendedorPdv: data.vendedorPdv,
                administrativoPdv: data.administrativoPdv,
                caixaPdv: data.caixaPdv,
                gerentePercentual: data.percentualGerente,
                vendedorPercentual: data.percentualVendedor,
                administrativoPercentual: data.percentualAdministrativo,
                caixaPercentual: data.percentualCaixa,
                gerente: data.gerente,
                vendedor: data.vendedor,
                administrativo: data.administrativo,
                caixa: data.caixa
            }));
            setChartAndTableData(mappedData);
        }
    }, [despesaPessoalData]);

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            const percentualCaixa = `${new Intl.NumberFormat('pt').format(data.caixaPercentual)}%`
            const percentualAdm = `${new Intl.NumberFormat('pt').format(data.administrativoPercentual)}%`
            const percentualVendedor = `${new Intl.NumberFormat('pt').format(data.vendedorPercentual)}%`
            const percentualGerente = `${new Intl.NumberFormat('pt').format(data.gerentePercentual)}%`
            const pdvGerente = `R$ ${data.gerentePdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvVendedor = `R$ ${data.vendedorPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvAdm = `R$ ${data.administrativoPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvCaixa = `R$ ${data.caixaPdv.toLocaleString('pt-BR').split(',')[0]}`;
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                    <p>{data.name}</p>
                    <p>CAIXA %: {percentualCaixa}</p>
                    <p>ADMINISTRATIVO %: {percentualAdm}</p>
                    <p>VENDEDOR %: {percentualVendedor}</p>
                    <p>GERENTE %: {percentualGerente}</p>
                    <p>GERENTE/PDV: {pdvGerente}</p>
                    <p>VENDEDOR/PDV: {pdvVendedor}</p>
                    <p>ADMINISTRATIVO/PDV: {pdvAdm}</p>
                    <p>CAIXA/PDV: {pdvCaixa}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div>
            <ResponsiveContainer width='99%' height={400}>
                <ComposedChart
                    width={1200}
                    height={400}
                    data={chartAndTableData}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 5,
                        bottom: 10
                    }}
                >
                    <XAxis dataKey="name" stroke="#000" axisLine={false} tickLine={false} style={{ fontWeight: 'bold' }} />
                    <YAxis hide />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                        align={windowWidth > 600 ? 'left' : 'center'}
                        layout={windowWidth > 600 ? 'vertical' : 'horizontal'}
                        iconSize={10}
                        wrapperStyle={(windowWidth > 600) ? { ...getLegendPosition(),  minWidth: '140px', width: '140px',maxWidth: '140px'} : { ...getLegendPosition() }}
                        formatter={(value, entry) => <span style={{ color: '#000', fontSize: '10px' }}>{value}</span>}
                        payload={[
                            { value: 'CAIXA %', type: "rect", color: "#e9dad5", },
                            { value: 'ADMINISTRATIVO %', type: "rect", color: "#d9eae0" },
                            { value: 'VENDEDOR %', type: "rect", color: "#e0e4ed" },
                            { value: 'GERENTE %', type: "rect", color: "#f4edda" },
                            { value: 'GERENTE / PDV', type: "line", color: "#ba7909" },
                            { value: 'VENDEDOR / PDV', type: "line", color: "#606f90" },
                            { value: 'ADMINITRATIVO / PDV', type: "line", color: "#3f8b65" },
                            { value: 'CAIXA / PDV', type: "line", color: "#692524" },

                        ]}
                    />
                    <Bar
                        dataKey="gerentePercentual"
                        name="GERENTE %"
                        fill="#f4edda"
                        stackId="123"
                    />
                    <Bar
                        dataKey="vendedorPercentual"
                        name="VENDEDOR %"
                        fill="#e0e4ed"
                        stackId="123"
                    />
                    <Bar
                        dataKey="administrativoPercentual"
                        name="ADMINISTRATIVO %"
                        fill="#d9eae0"
                        stackId="123"
                    />
                    <Bar
                        dataKey="caixaPercentual"
                        name="CAIXA %"
                        fill="#e9dad5"
                        stackId="123"
                    />
                    <Line type="monotone" dataKey="gerentePercentual" name="GERENTE/PDV" stroke="#ba7909" dot={false}>
                        <LabelList
                            dataKey="gerentePdv"
                            fill="#ba7909"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="vendedorPercentual" name="VENDEDOR/PDV" stroke="#606f90" dot={false}>
                        <LabelList
                            dataKey="vendedorPdv"
                            fill="#606f90"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="administrativoPercentual" name="ADMINISTRATIVO/PDV" stroke="#3f8b65" dot={false}>
                        <LabelList
                            dataKey="administrativoPdv"
                            fill="#3f8b65"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="caixaPercentual" name="CAIXA/PDV" stroke="#692524" dot={false}>
                        <LabelList
                            dataKey="caixaPdv"
                            fill="#692524"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                </ComposedChart>
            </ResponsiveContainer>
            <div style={{ marginRight: '40px' }}>
                <table
                    style={{
                        width: '100%',
                        borderTop: '1px solid #000',
                        borderBottom: '1px solid #000',
                        overflow: 'auto',
                        tableLayout: 'fixed'
                    }}>
                    <tbody>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>GERENTE</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.gerente.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.gerentePercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>VENDEDOR</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.vendedor.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.vendedorPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>ADM</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.administrativo.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.administrativoPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>CAIXA</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.caixa.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.caixaPercentual)}%`}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
